import { useEffect, useState } from "react";
import axios from "../../utils/axiosInstance";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
const Footer = () => {
  const [footerData, setFooterData] = useState(null);

  const iconMap = {
    FaFacebook: <FaFacebook />,
    FaTwitter: <FaTwitter />,
    FaInstagram: <FaInstagram />,
    FaLinkedin: <FaLinkedin />,
  };

  useEffect(() => {
    console.log("Footer mounted"); // 🔹 تست mount
    axios.get("/footer").then((res) => {
      console.log("Footer data:", res); // 🔹 تست داده
      if ((res.data.status = 200)) setFooterData(res.data);
    });
  }, []);

  if (!footerData) return <div>Loading Footer...</div>; // 🔹 برای تست

  return (
    <footer className="bd-footer bg-dark text-white py-4  mt-5">
      <div className="container">
        <div className="row">
          {/* توضیح کوتاه */}
          <div className="col-md-4 mb-3">
            <h5>{footerData.title}</h5>
            <p>{footerData.description}</p>
          </div>

          {/* لینک‌ها */}
          <div className="col-md-4 mb-3">
            <h5>Links</h5>
            <ul className="list-unstyled">
              {footerData.links.map((link, i) => (
                <li key={i}>
                  <a href={link.url} className="text-white">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* اطلاعات تماس و شبکه‌های اجتماعی */}
          <div className="col-md-4 mb-3">
            <h5>Contact</h5>
            <p>{footerData.contact}</p>
            <div className="d-flex gap-2">
              {footerData.socialLinks.map((s, i) => (
                <a
                  key={i}
                  href={s.url}
                  className="text-white fs-5"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {/* 🔹 اینجا اسم آیکون رو به کامپوننت واقعی تبدیل می‌کنیم */}
                  {iconMap[s.icon] || s.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
//   const [footerData, setFooterData] = useState(null);

//   useEffect(() => {
//     fetch("/api/settings/footer") // از بک‌اند دیتا رو می‌گیره
//       .then((res) => res.json())
//       .then((data) => setFooterData(data))
//       .catch((err) => console.error("Error loading footer:", err));
//   }, []);

//   if (!footerData) return null;

//   return (
//     <footer className="bg-gray-900 text-gray-200 py-10 mt-10">
//       <div className="container mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
//         {/* بخش لوگو و توضیح */}
//         <div>
//           <img src={footerData.logo} alt="Logo" className="h-12 mb-4" />
//           <p className="text-sm">{footerData.description}</p>
//         </div>

//         {/* ستون‌های لینک */}
//         {footerData.links.map((col, i) => (
//           <div key={i}>
//             <h4 className="font-bold text-lg mb-3">{col.title}</h4>
//             <ul className="space-y-2">
//               {col.items.map((item, idx) => (
//                 <li key={idx}>
//                   <a
//                     href={item.url}
//                     className="hover:text-white transition-colors"
//                   >
//                     {item.label}
//                   </a>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         ))}

//         {/* شبکه‌های اجتماعی */}
//         <div>
//           <h4 className="font-bold text-lg mb-3">Follow Us</h4>
//           <div className="flex space-x-4">
//             {footerData.socials.map((s, idx) => (
//               <a key={idx} href={s.url} target="_blank" rel="noreferrer">
//                 <img src={s.icon} alt={s.name} className="h-6 w-6" />
//               </a>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* کپی‌رایت */}
//       <div className="text-center text-sm text-gray-400 mt-8 border-t border-gray-700 pt-4">
//         © {new Date().getFullYear()} {footerData.copyright}
//       </div>
//     </footer>
//   );
//   const [footer, setFooter] = useState(null);

//   useEffect(() => {
//     axios.get("/footer").then((res) => setFooter(res.data));
//   }, []);

//   if (!footer) return null;

//   return (
//     <footer className="bg-gray-900 text-white py-10 mt-10">
//       <div className="container mx-auto grid grid-cols-2 md:grid-cols-4 gap-6">
//         {footer.sections.map((section, idx) => (
//           <div key={idx}>
//             <h4 className="font-bold mb-3">{section.title}</h4>
//             <ul>
//               {section.links.map((link, i) => (
//                 <li key={i}>
//                   <a href={link.url} className="text-gray-400 hover:text-white">
//                     {link.label}
//                   </a>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         ))}
//         <div>
//           <h4 className="font-bold mb-3">Follow Us</h4>
//           <div className="flex gap-4">
//             {footer.socialLinks.map((social, i) => (
//               <a key={i} href={social.url} target="_blank" rel="noreferrer">
//                 <i className={`fab fa-${social.icon} text-xl`}></i>
//               </a>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div className="text-center mt-6 text-gray-400">{footer.copyright}</div>
//     </footer>
//   );
//   useEffect(() => {
//     // داده نمونه برای تست
//     const sampleData = {
//       title: "CoolMarket",
//       description: "Your favorite electronics store",
//       links: [
//         { label: "About Us", url: "/about" },
//         { label: "Contact", url: "/contact" },
//         { label: "FAQ", url: "/faq" },
//         { label: "Terms of Service", url: "/terms" },
//       ],
//       contact: "Email: support@coolmarket.com | Phone: +31 123 456 789",
//       social: [
//         { icon: "facebook", url: "https://facebook.com" },
//         { icon: "twitter", url: "https://twitter.com" },
//         { icon: "instagram", url: "https://instagram.com" },
//       ],
//     };

//     setFooterData(sampleData);
//   }, []);
